import { render } from "./ManageQuextConcept.vue?vue&type=template&id=51892e10&scoped=true"
import script from "./ManageQuextConcept.vue?vue&type=script&lang=js"
export * from "./ManageQuextConcept.vue?vue&type=script&lang=js"

import "./ManageQuextConcept.vue?vue&type=style&index=0&id=51892e10&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51892e10"]])

export default __exports__